/* eslint-disable import/no-named-as-default-member */
import UTIL_INDEX_MAP from './indexMap';

const injectIntoDoc = (doc) => {
	if (!doc.gpsreadings && !doc.gpsreadingsKeyToIndexes) {
		return doc;
	}
	const clone = { ...doc };
	clone.gpsreadingsKeyToIndexes = {};

	if (clone.gpsreadings && clone.gpsreadings?.length) {
		clone.gpsreadingsKeyToIndexes = UTIL_INDEX_MAP.createIndexMap(clone.gpsreadings);
	}		

	return clone;
}

const injectIntoJobData = (arrData = []) => {
	return arrData.map(doc => injectIntoDoc(doc));
}

const injectIntoJobGlobalData = (globalData) => {
	const clone = {...globalData };
	const cloneMasterLST = {...clone.MasterLST };
	clone.MasterLST = cloneMasterLST;

	const fileKeys = Object.keys(cloneMasterLST).filter(v => v && v !== 'size' && v !== 'length'); // master lst somtimes has a reference to file count, but don't I recall the exact property name. checking for both size & length.
	fileKeys.forEach(fileKey => {
		cloneMasterLST[fileKey] = injectIntoDoc(cloneMasterLST[fileKey]);
	})

	return clone;
}

const injectIntoCisviewReadings = (sliceCisviewReadings) => {
	if (
		!sliceCisviewReadings.convertedReadings && 
		!sliceCisviewReadings.convertedReadingsKeyToIndexes &&
		!sliceCisviewReadings.unsortedConvertedReadings && 
		!sliceCisviewReadings.unsortedConvertedReadingsKeyToIndexes
	) {
		return sliceCisviewReadings;
	}
	const clone = {...sliceCisviewReadings };;
	clone.convertedReadingsKeyToIndexes = {};
	clone.unsortedConvertedReadingsKeyToIndexes = {};

	if (clone.convertedReadings && clone.convertedReadings?.length) {
		clone.convertedReadingsKeyToIndexes = UTIL_INDEX_MAP.createIndexMap(clone.convertedReadings);
	}		

	if (clone.unsortedConvertedReadings && clone.unsortedConvertedReadings?.length) {
		clone.unsortedConvertedReadingsKeyToIndexes = UTIL_INDEX_MAP.createIndexMap(clone.unsortedConvertedReadings);
	}		

	return clone;
}

const UTIL_INJECT_INDEX_MAP_REDUX = {
	injectIntoDoc,
	injectIntoJobData,
	injectIntoJobGlobalData,
	injectIntoCisviewReadings,
}

export default UTIL_INJECT_INDEX_MAP_REDUX;